import React from "react";

export function CommunityAdminRule(props) {

    return <div>
rule!
    </div>
}